import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaXTwitter, FaYoutube, FaFacebook, FaTiktok, FaInstagram } from "react-icons/fa6";
import "../styles/proveedores.css";

const IMGBB_API_KEY = "889599d23baca8283c1f376d1f23da5f";

const platforms = [
  { value: "X", label: "X (Twitter)", icon: <FaXTwitter /> },
  { value: "Youtube", label: "YouTube", icon: <FaYoutube /> },
  { value: "Facebook", label: "Facebook", icon: <FaFacebook /> },
  { value: "TikTok", label: "TikTok", icon: <FaTiktok /> },
  { value: "Instagram", label: "Instagram", icon: <FaInstagram /> },
];

const SERVER_ENDPOINT = "/api/sendpulse";

interface NewService {
  name: string;
  description: string;
  category: string;
  imageFile: File | null;
  image_url: string;
  contact_email: string;
  wallet: string;
  phone?: string;
  price?: number; 
  isFree?: boolean;
}


const ErrorModal = ({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) => (
  <div>
    <div>
      <h3>⚠️ Error de Validación</h3>
      <p>{message}</p>
      <button className="button-primary" onClick={onClose}>
        Entendido
      </button>
    </div>
  </div>
);

const Proveedores = ({ setMessage }: { setMessage: (msg: string) => void }) => {
  const navigate = useNavigate();

  const [newService, setNewService] = useState<NewService>({
  name: "",
  description: "",
  category: "",
  imageFile: null,
  image_url: "",
  contact_email: "",
  wallet: "",
  phone: "",
  price: undefined,
  isFree: false,
});

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (
  e:
    | React.ChangeEvent<HTMLInputElement>
    | React.ChangeEvent<HTMLTextAreaElement>
    | React.ChangeEvent<HTMLSelectElement>
) => {
  const { name, value } = e.target;
  setNewService((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;

    if (file) {
      const allowedTypes = ["image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setMessage("❌ Formato de imagen no permitido. Usa JPG o PNG.");
        setNewService((prev) => ({ ...prev, imageFile: null, image_url: "" }));
        return;
      }

      setMessage("");
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewService((prev) => ({
          ...prev,
          imageFile: file,
          image_url: reader.result as string,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setNewService((prev) => ({ ...prev, imageFile: null, image_url: "" }));
    }
  };

  const uploadToImgBB = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(
      `https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();
    if (!data.success) {
      throw new Error("Error al subir la imagen a ImgBB.");
    }

    return data.data.url; 
  };



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (
  !newService.name ||
  !newService.description ||
  !newService.category ||
  !newService.imageFile ||
  !newService.contact_email ||
  !newService.wallet ||
  (newService.isFree === false && (newService.price === undefined || newService.price < 0))
) {
  setErrorMessage(
    "Debes diligenciar toda la información"
  );
  setShowErrorModal(true);
  return;
}



    setIsSubmitting(true);
    setMessage("Procesando: Subiendo imagen y enviando solicitud...");

    try {
      const imageUrlPublic = await uploadToImgBB(newService.imageFile);

      const registrationData = {
  name: newService.name,
  description: newService.description,
  category: newService.category,
  image_url: imageUrlPublic,
  contact_email: newService.contact_email,
  wallet: newService.wallet,
  phone: newService.phone,
  price: newService.price ?? 0,
  timestamp: new Date().toISOString(),
};



      const response = await fetch(SERVER_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(registrationData),
      });

      if (!response.ok)
        throw new Error(`Error en servidor: ${response.statusText}`);

      setMessage("✅ Solicitud procesada y correo enviado correctamente.");

      setNewService({
  name: "",
  description: "",
  category: "",
  imageFile: null,
  image_url: "",
  contact_email: "",
  wallet: "",
  phone: "",
});
    } catch (error) {
      console.error("Error general:", error);
      setMessage("❌ Error al procesar la solicitud.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-modal form-group">
      <h1>Activacion como creador</h1>
      <h2>Recibe recompensas por crear tu evento en la Mox App</h2>
      <p>
        Diligencia el formulario. En maximo 24 horas recibiras respuesta de tu activacion en nuestro ecosistema.
      </p>

      <form onSubmit={handleSubmit} className="provider-form" noValidate>
        
        <div className="form-group">
          <label htmlFor="name">Nickname:*</label>
          <input
            id="name"
            type="text"
            name="name"
            value={newService.name}
            onChange={handleChange}
            required
            maxLength={100}
            disabled={isSubmitting}
          />
        </div>
        <div className="form-group">
  <label>Red Social:*</label>

  <div className="platform-selector">
    {platforms.map((platform) => (
      <button
        key={platform.value}
        type="button"
        className={`platform-option ${
          newService.category === platform.value ? "active" : ""
        }`}
        onClick={() =>
          setNewService((prev) => ({
            ...prev,
            category: platform.value, 
          }))
        }
        disabled={isSubmitting}
      >
        <span className="icon">{platform.icon}</span>
        <span>{platform.label}</span>
      </button>
    ))}
  </div>

  {!newService.category && (
    <small className="field-error">Selecciona una red social</small>
  )}
</div>
        <div className="form-group">
          <label htmlFor="description">Descripción detallada:*</label>
          <textarea
            id="description"
            name="description"
            value={newService.description}
            onChange={handleChange}
            required
            rows={5}
            disabled={isSubmitting}
          />
        </div>
        <div className="form-group">
          <label htmlFor="wallet">Mox Billetera*</label>
          <input
            id="wallet"
            type="text"
            name="wallet"
            value={newService.wallet}
            onChange={handleChange}
            required
            maxLength={100}
            placeholder="Copia la wallet del inicio"
            disabled={isSubmitting}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="imageFile">Imagen principal (JPG o PNG):*</label>
          <input
            id="imageFile"
            type="file"
            name="imageFile"
            accept=".jpg, .jpeg, .png"
            onChange={handleImageChange}
            required={!newService.image_url}
            disabled={isSubmitting}
          />
          {newService.image_url && (
            <div className="image-preview-container">
              <p>Previsualización:</p>
              <img
                src={newService.image_url}
                alt="Previsualización del servicio"
                style={{
                  maxWidth: "200px",
                  maxHeight: "200px",
                  marginTop: "10px",
                }}
              />
            </div>
          )}
        </div>
                <div className="form-group">
          <label>correo electronico:*</label>
          <input
            type="email"
            name="contact_email"
            value={newService.contact_email}
            onChange={handleChange}
            placeholder="ejemplo@correo.com"
            disabled={isSubmitting}
          />
        </div>
        <div className="form-group">
          <label>Teléfono:*</label>
          <input
            type="number"
            name="phone"
            value={newService.phone || ""}
            onChange={handleChange}
            placeholder="+573000000000"
            disabled={isSubmitting}
          />
        </div>
        <div className="form-group">
  <label>
    Servicio gratuito:
    <input
      type="checkbox"
      name="isFree"
      checked={newService.isFree}
      onChange={(e) =>
        setNewService((prev) => ({
          ...prev,
          isFree: e.target.checked,
          price: e.target.checked ? 0 : undefined, 
        }))
      }
      disabled={isSubmitting}
    />
  </label>
</div>

{!newService.isFree && (
  <div className="form-group">
    <label htmlFor="price">Precio (COP/UMQ):*</label>
    <input
      id="price"
      type="number"
      name="price"
      min={0}
      value={newService.price ?? ""}
      onChange={handleChange}
      required
      disabled={isSubmitting}
    />
  </div>
)}
        <button type="submit" className="button-primary" disabled={isSubmitting}>
          {isSubmitting ? "Enviando Solicitud..." : "Solicitud de activacion"}
        </button>
      </form>

      {showErrorModal && (
        <ErrorModal message={errorMessage} onClose={() => setShowErrorModal(false)} />
      )}

      <button className="button-exit" onClick={() => navigate("/home")}>
        Volver
      </button>
      <p><strong>*Campo obligatorio</strong></p>
    </div>
  );
};

export default Proveedores;

